import React, { useState } from 'react';
import { DropDownButton, DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';
import * as svg from '@progress/kendo-svg-icons';
import { SvgIcon } from '@progress/kendo-react-common';
import { Checkbox } from '@progress/kendo-react-inputs';
import * as ActionSlice from '../../../../slices/ActionSlice';
import * as EmailActionSlice from '../../../../slices/EmailActionSlice';
import { useReduxDispatch, useReduxSelector } from '../../../../redux/hooks';
import { aiApi } from '../../../../redux/api/AIApi';

type mode = 'action' | 'email';

const AINotes: React.FC<{ controlMode?: mode }> = ({ controlMode }) => {
    const dispatch = useReduxDispatch();
    const [translate] = aiApi.useTranslateNoteMutation();
    const { action, translateOption, originalNote } = useReduxSelector(state => state.actionDetails);
    const { email, translateOption: emailTranslateOption, originalNote: originalEmailBody } = useReduxSelector(state => state.emailAction);
    const handleSelect = (event: DropDownButtonItemClickEvent) => {

        //Set the selected option in the ACTION sLICE
        dispatch(ActionSlice.SetTranslationOption(event.itemIndex));

        //Save the original note
        if (originalNote === null) dispatch(ActionSlice.SetOriginalNote(action.HTML_Notes));

        //Translate the note
        if (event.itemIndex === 0) {
            //Original
            dispatch(ActionSlice.SetHTML_Notes(originalNote));
            //Remove the NOte "backup'"
            dispatch(ActionSlice.SetOriginalNote(null));
        } else {
            //More Professional, More Concise, More Friendly
            translate({ Notes: action.HTML_Notes, TransformId: event.itemIndex }).unwrap().then((data) => {
                dispatch(ActionSlice.SetHTML_Notes(data.Content[0].Text));
            }).catch((e) => { });
        }
    };

    const handleEmailSelect = (event: DropDownButtonItemClickEvent) => {

        //Set the selected option in the ACTION sLICE
        dispatch(EmailActionSlice.setTranslationOption(event.itemIndex));

        //Save the original note
        if (originalEmailBody === null) dispatch(EmailActionSlice.setOriginalNote(email.HTML_Note));

        //Translate the note
        if (event.itemIndex === 0) {
            //Original
            dispatch(EmailActionSlice.setNotes(originalEmailBody));
            //Remove the NOte "backup'"
            dispatch(EmailActionSlice.setOriginalNote(null));
        } else {
            //More Professional, More Concise, More Friendly
            translate({ Notes: email.HTML_Note, TransformId: event.itemIndex }).unwrap().then((data) => {
                dispatch(EmailActionSlice.setNotes(data.Content[0].Text));
            }).catch((e) => { });
        }
    };
    const optionSelectred = controlMode === 'email' ? emailTranslateOption : translateOption;

    const settings = [
        <><Checkbox checked={optionSelectred === 0} /> Original</>,
        <><Checkbox checked={optionSelectred === 1} /><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-briefcase" viewBox="0 0 16 16">
            <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5m1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0M1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5" />
        </svg><span className='ps-1'>More Professional</span></>
        , <><Checkbox checked={optionSelectred === 2} /><SvgIcon icon={svg.minHeightIcon} /><span className='ps-1'>More Concise</span></>
        , <><Checkbox checked={optionSelectred === 3} /><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-emoji-smile" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
            <path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.5 3.5 0 0 0 8 11.5a3.5 3.5 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5" />
        </svg><span className='ps-1'>More Friendly</span></>
    ];

    const nope = false;
    return (
        <>
            <div className="mr-2">
                <DropDownButton onItemClick={controlMode === 'email' ? handleEmailSelect : handleSelect} className="ai-translate-button" popupSettings={{ popupClass: 'ai-translate-popup' }} items={settings} svgIcon={svg.sparklesIcon} text="AI Assist" endIcon={<SvgIcon icon={svg.chevronDownIcon} />} />
            </div>
        </>
    );
};

export default AINotes;